'use strict';

module.exports = function (ngModule) {
    ngModule.directive('iocDesc', require('./iocdesc'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/iocdesc/index.js
 **/